import api from "@common/api/index.js";
import dateTool from "@/utils/dateTool.js";

export default {
  /**
   * 账单类型
   */
  billType: {
    // 业主
    proprietor: [
      { value: 1, label: "托管收入" },
      { value: 2, label: "托管支出" }
    ],
    // 物业
    property: [
      { value: 3, label: "托管收入" },
      { value: 4, label: "托管支出" },
      { value: 5, label: "个人租凭收入" },
      { value: 51, label: "公司租凭收入" }
    ],
    // 个人
    person: [{ value: 6, label: "租凭支出" }],
    company: [{ value: 7, label: "租凭支出" }]
  },
  /**
   * 查询账单
   * @param {*} startTimeLeft 起始结算时间
   * @param {*} startTimeRight 结束结算时间
   * @param {*} type 账单类型
   */
  getBillData(startTimeLeft, startTimeRight, type) {
    let getDataApi = null;
    switch (type) {
      case 1:
        getDataApi = api.rentalArea.getRentalAreaTrusteeshipIncomeBillForProprietor(
          0,
          startTimeLeft,
          startTimeRight,
          [],
          -1
        );
        break;
      case 2:
        getDataApi = api.rentalArea.getRentalAreaTrusteeshipExpenditureBillForProprietor(
          0,
          startTimeLeft,
          startTimeRight,
          [],
          -1
        );
        break;
      case 3:
        getDataApi = api.rentalArea.getRentalAreaTrusteeshipIncomeBillForProperty(
          0,
          startTimeLeft,
          startTimeRight,
          [],
          -1
        );
        break;
      case 4:
        getDataApi = api.rentalArea.getRentalAreaTrusteeshipExpenditureBillForProperty(
          0,
          startTimeLeft,
          startTimeRight,
          [],
          -1
        );
        break;
      case 5:
        getDataApi = api.rentalArea.getLeaseIncomeBillForProperty(
          0,
          startTimeLeft,
          startTimeRight,
          1,
          [],
          -1
        );
        break;
      case 51:
        getDataApi = api.rentalArea.getLeaseIncomeBillForProperty(
          0,
          startTimeLeft,
          startTimeRight,
          2,
          [],
          -1
        );
        break;
      case 6:
        getDataApi = api.rentalArea.getLeaseExpenditureBillForPersonalLessee(
          startTimeLeft,
          startTimeRight,
          [],
          -1
        );
        break;
      case 7:
        getDataApi = api.rentalArea.getLeaseExpenditureBillForCompanyLessee(
          startTimeLeft,
          startTimeRight,
          [],
          -1
        );
        break;
    }

    return getDataApi;
  },
  /**
   * 手动付款
   * @param {*} billId 账单id
   * @param {*} paymentMode 付款方式 1 钱包 2 现金付款
   * @param {*} type 账单类型
   */
  paymentBill(billId, paymentMode, type) {
    let resApi = null;
    switch (type) {
      case 1:
      case 2:
        resApi = api.rentalArea.paymentForProprietorRentalAreaTrusteeshipBill(
          0,
          billId,
          paymentMode
        );
        break;
      case 3:
      case 4:
        resApi = api.rentalArea.paymentForPropertyRentalAreaTrusteeshipBill(
          0,
          billId,
          paymentMode
        );
        break;
      case 5:
      case 6:
      case 7:
        resApi = api.rentalArea.paymentForLeaseBill(billId, paymentMode);
        break;
    }
    return resApi;
  },
  getLastMonth() {
    var nowdays = new Date();
    var year = nowdays.getFullYear();
    var month = nowdays.getMonth();
    if (month == 0) {
      month = 12;
      year = year - 1;
    }
    if (month < 10) {
      month = "0" + month;
    }

    var myDate = new Date(year, month, 0);
    var startDate = year + "/" + month + "/01"; //上个月第一天
    var endDate = year + "/" + month + "/" + myDate.getDate(); //上个月最后一天
    return { startDate: startDate, endDate: endDate };
  }
};
